import React from 'react';

const NaboraEconomy= ({ slug }) => {
  return (
    <div className="py-4 px-6 bg-[#0a0a0f]">
      <div className="max-w-4xl mx-auto text-center">
        <div className="uppercase text-yellow-400 tracking-widest mb-4 text-lg lg:text-xl">💜 WHY NABORA EXISTS</div>
        
        <h2 className="text-sm lg:text-lg text-gray-100 font-bold leading-none mb-2">
          Small businesses shouldn't disappear because they can't afford expensive digital marketing.
        </h2>
        
        <div className="max-w-2xl mx-auto text-sm lg:text-lg text-slate-200 leading-relaxed mb-2">
          Nabora gives neighbourhood entrepreneurs a recurring digital stage to showcase products, 
          connect with nearby customers, offer fair discounts, and participate in a community-driven local economy. 
        </div>

        <div className="grid grid-cols-1 lg:grid-cols-3 gap-2 text-left">
          {[
            { emoji: '🏘️', title: 'Community First', desc: 'Neighborhood trust over endless scrolling' },
            { emoji: '🚀', title: 'Youth Powered', desc: 'Gen Z DMDs building local ecosystems' },
            { emoji: '📈', title: 'Behaviour Driven', desc: 'Streak economy and BOS rewards' }
          ].map((item, i) => (
            <div key={i} className="bg-slate-900/60 p-2 rounded-3xl border border-white/5">
              <h3 className="font-semibold text-gray-100 text-sm lg:text-lg mb-2">{item.emoji}{" "}{item.title}</h3>
              <p className="text-slate-200 text-sm lg:text-sm">{item.desc}</p>
            </div>
          ))}
        </div>
      </div>
    </div>
  );
};

export default NaboraEconomy;